<template>
	<div>
		<div
			v-if="isDisplaySmileAndPass"
			class="bg-blue-100 d-flex flex-row nowrap w-100 my-2 py-2 px-3 align-items-center text-primary-blue"
			style="border-radius: 10px"
		>
			<div class="me-1">
				<svg :width="iconSize" :height="iconSize" class="icon">
					<use xlink:href="#___icon___smile-and-pass"></use>
				</svg>
			</div>
			<div class="ms-2 text-start font-weight-500 font-size-14">
				{{ content.planningSearch_banners_smileAndPass }}
			</div>
		</div>

		<div
			v-if="isDisplayTenOff"
			class="bg-green-100 d-flex flex-row nowrap w-100 my-2 py-2 px-3 align-items-center"
			style="border-radius: 10px"
		>
			<div class="me-1">
				<svg color="#9BC940" :width="iconSize" :height="iconSize" class="icon">
					<use xlink:href="#___icon___ten-off"></use>
				</svg>
			</div>
			<div class="ms-2 text-start font-weight-500 font-size-14">
				{{ content.planningSearch_banners_tenPercentDeposit }}
			</div>
		</div>

		<div
			v-if="annulation"
			class="bg-green-100 d-flex flex-row nowrap w-100 my-2 py-2 px-3 align-items-center text-primary-green"
			style="border-radius: 10px"
		>
			<div
				class="me-1"
				v-if="language === 'fr-FR' || this.language === 'fr-FR-CSE'"
			>
				<svg :width="iconSize" :height="iconSize" class="icon">
					<use xlink:href="#___icon___annnulation-j45"></use>
				</svg>
			</div>
			<div class="me-1" v-else>
				<svg :width="iconSize" :height="iconSize" class="icon">
					<use xlink:href="#___icon___annnulation-d45"></use>
				</svg>
			</div>
			<div class="ms-2 text-start font-weight-500 font-size-14">
				{{ annulation }}
			</div>
		</div>
		<div class="subcaption text-grey-800" v-if="hasAnnulation45Criteria">
			{{ content.planningSearch_banners_annulation45_under_sentence }}
		</div>
		<div
			v-if="isDisplayBestPriceGuarantee"
			class="bg-green-100 d-flex flex-row nowrap w-100 my-2 py-2 px-3 align-items-center text-primary-green"
			style="border-radius: 10px"
		>
			<div>
				<svg width="25" height="25" class="icon">
					<use xlink:href="#___icon___meilleurs-tarifs-negcocies"></use>
				</svg>
			</div>
			<span class="text-green-800 ms-2 font-weight-500 font-size-14">
				{{ content.banner_bestPriceGuarantee }}
			</span>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex"
import store from "@/vue/planning/store/store"

export default {
	store,
	name: "Banners",
	props: {
		iconSize: {
			type: Number,
			default: 24,
		},
		prestation: {
			type: Object,
			default: () => {
				return {}
			},
		},
		lihe: {
			type: Object,
			default: () => {
				return {}
			},
		},
		startDate: String,
	},
	components: {},

	computed: {
		...mapState(["content", "language"]),
		criteriasSet() {
			if (this.lihe) return new Set(this.lihe.criteriasList)
			if (this.prestation) return this.prestation.criteriasSet
			throw new Error("banners.vue requires either lihe or prestation")
		},
		isDisplaySmileAndPass() {
			if (!this.criteriasSet || window.seasonManager.season === "E")
				return false

			if (this.criteriasSet.has("700")) {
				return true
			}
			return false
		},
		isDisplayTenOff() {
			if (
				!this.prestation.variants ||
				(this.prestation && this.prestation.variants.length === 0)
			)
				return false

			const currentDate = new Date()
			if (!this.startDate)
				throw new Error("startDate is mandatory in banners.vue")
			const startDate = new Date(this.startDate)

			const differenceMilliseconds = startDate - currentDate
			const differenceDays = differenceMilliseconds / 1000 / 60 / 60 / 24
			if (differenceDays > 30) return true
			return false
		},
		annulation() {
			if (!this.criteriasSet) return ""

			if (this.criteriasSet.has("961")) {
				// Annulation à J-15 Hiver (criteria ID=961)
				return this.content.planningSearch_banners_annulation15
			} else if (this.hasAnnulation45Criteria) {
				// Annulation à J-45 Hiver (criteria ID=977)
				return this.content.planningSearch_banners_annulation45
			} else if (this.criteriasSet.has("816")) {
				// Annulation à J-15 Eté (criteria ID=816)
				return this.content.planningSearch_banners_annulation15
			} else if (this.criteriasSet.has("976")) {
				// Annulation à J-45 Eté (criteria ID=976)
				return this.content.planningSearch_banners_annulation45
			}
			return ""
		},
		hasAnnulation45Criteria() {
			return this.criteriasSet.has("977")
		},
		isDisplayBestPriceGuarantee() {
			return this.lihe.lodgingTypeId !== "23"
		},
	},
}
</script>

<style scoped></style>
